import api from './api';
import { Store, CreateStoreRequest, PaginatedStoreResponse } from '../types';
import { API_ENDPOINTS } from '../constants';

const storeService = {
  /**
   * Get paginated list of stores
   */
  getStores: async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    cluster_id?: string;
  }): Promise<PaginatedStoreResponse> => {
    const response = await api.get<{ success: boolean; message: string; data: PaginatedStoreResponse }>(API_ENDPOINTS.STORES.LIST, {
      params,
    });
    return response.data.data;
  },
  
  /**
   * Get store by ID
   */
  getStoreById: async (id: string): Promise<Store> => {
    const response = await api.get<{ success: boolean; message: string; data: Store }>(API_ENDPOINTS.STORES.GET_BY_ID(id));
    return response.data.data;
  },
  
  /**
   * Create new store
   */
  createStore: async (storeData: CreateStoreRequest): Promise<Store> => {
    const response = await api.post<{ success: boolean; message: string; data: Store }>(
      API_ENDPOINTS.STORES.CREATE,
      storeData
    );
    return response.data.data;
  },
  
  /**
   * Update store
   */
  updateStore: async (id: string, storeData: Partial<CreateStoreRequest>): Promise<Store> => {
    const response = await api.put<{ success: boolean; message: string; data: Store }>(API_ENDPOINTS.STORES.UPDATE(id), storeData);
    return response.data.data;
  },
  
  /**
   * DISABLED: Delete store - not permitted for anyone.
   * The backend hard-deletes the store plus all of its attendance and leave
   * records, and unassigns every user in it. Irreversible.
   */
  // deleteStore: async (id: string): Promise<void> => {
  //   await api.delete(API_ENDPOINTS.STORES.DELETE(id));
  // },

  /**
   * Update store attendance settings
   */
  updateAttendanceSettings: async (id: string, settings: any): Promise<Store> => {
    const response = await api.put<{ success: boolean; message: string; data: Store }>(
      API_ENDPOINTS.STORES.UPDATE_ATTENDANCE_SETTINGS(id), 
      settings
    );
    return response.data.data;
  },

  /**
   * Update store manager
   */
  updateStoreManager: async (
    id: string, 
    managerId: string | null, 
    demoteToRole?: string
  ): Promise<Store> => {
    const response = await api.put<{ success: boolean; message: string; data: Store }>(
      API_ENDPOINTS.STORES.UPDATE_MANAGER(id), 
      { 
        manager_id: managerId,
        demote_to_role: demoteToRole 
      }
    );
    return response.data.data;
  },
};

export default storeService;
